import { render, staticRenderFns } from "./LayananGroups.vue?vue&type=template&id=407c7bf0&scoped=true"
import script from "./LayananGroups.vue?vue&type=script&lang=js"
export * from "./LayananGroups.vue?vue&type=script&lang=js"
import style0 from "./LayananGroups.vue?vue&type=style&index=0&id=407c7bf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407c7bf0",
  null
  
)

export default component.exports